<ng-container [formGroup]="formGroup">
  <div class="gift-mode-section" formGroupName="offer">
    <span class="field-label">Gift Mode</span>
    <pdq-radio-group formControlName="giftMode">
      <pdq-radio-button
        [value]="GiftMode.SINGLE"
        text="Single Gift"
        subText="One specific product and variant — no customer selection"
        [checked]="formGroup.get('offer.giftMode').value === GiftMode.SINGLE">
      </pdq-radio-button>
      <pdq-radio-button
        [value]="GiftMode.MULTIPLE"
        text="Multiple Gifts"
        subText="Customer picks from multiple products or variants"
        [checked]="formGroup.get('offer.giftMode').value === GiftMode.MULTIPLE"
        [disabled]="isAutoApplyEnabled"
        [tooltip]="
          isAutoApplyEnabled
            ? 'Disable \'Auto-Apply Gift If Product Is Free\' in Settings tab to enable this option'
            : ''
        "
        [tooltipAlwaysInteractive]="true">
      </pdq-radio-button>
    </pdq-radio-group>
    @if (isMultipleGifts) {
      <div class="toggle-group" formGroupName="offer">
        <button
          type="button"
          [class.active]="formGroup.get('offer.productDisplayType').value === ProductDisplayType.LIST"
          (click)="formGroup.get('offer.productDisplayType').setValue(ProductDisplayType.LIST)">
          <pdq-icon icon="two-rectangle" size="small"></pdq-icon>
          List
        </button>
        <button
          type="button"
          [class.active]="formGroup.get('offer.productDisplayType').value === ProductDisplayType.COMPACT"
          (click)="formGroup.get('offer.productDisplayType').setValue(ProductDisplayType.COMPACT)">
          <pdq-icon icon="rectangle" size="small"></pdq-icon>
          Compact
        </button>
      </div>
    }
  </div>

  @if (isMultipleGifts) {
    <div class="product-list-section">
      <span class="product-list-section__label">Product List</span>
      <pdq-product-list
        variant="summary"
        [products]="productsForDisplay"
        [currencySymbol]="shopCurrencySymbol"
        emptyMessage="No products selected"
        (actionClick)="onAddProducts()">
      </pdq-product-list>
    </div>
  } @else {
    <pdq-product-list
      variant="summary"
      selectionMode="single"
      [products]="productsForDisplay"
      [currencySymbol]="shopCurrencySymbol"
      emptyMessage="No products selected"
      (actionClick)="onAddProducts()">
    </pdq-product-list>
  }

  @if (!isMultipleGifts && !isAutoApplyEnabled) {
    <pdq-checkbox
      [formControl]="formGroup.get('settings.productDetails.hideOfferDetails')"
      label="Hide Product Details From Pop Up"
      labelSize="small">
    </pdq-checkbox>
  }
  <div class="hide-in-cart-section">
    <pdq-checkbox
      [formControl]="formGroup.get('settings.productDetails.hideIfProductIsInCart')"
      label="Hide Offer If The User Already Has This Product In Their Cart"
      labelSize="small">
    </pdq-checkbox>
    @if (formGroup.get('settings.productDetails.hideIfProductIsInCart').value) {
      <div #hideInCartLevel class="hide-in-cart-level">
        <span class="hide-in-cart-level__title body-14-medium">Detection Level</span>
        <pdq-radio-group [formControl]="formGroup.get('settings.productDetails.hideIfProductIsInCartLevel')">
          @for (option of hideInCartLevelOptions; track option.value) {
            <pdq-radio-button
              [value]="option.value"
              [checked]="formGroup.get('settings.productDetails.hideIfProductIsInCartLevel').value === option.value"
              [text]="option.label"
              [subText]="option.description">
            </pdq-radio-button>
          }
        </pdq-radio-group>
      </div>
    }
  </div>

  <pdq-checkbox
    [formControl]="formGroup.get('settings.productDetails.discountConfiguration.enabled')"
    label="Set Discount Configuration"
    labelSize="small">
  </pdq-checkbox>
  @if (formGroup.get('settings.productDetails.discountConfiguration.enabled')?.value) {
    <div class="flex-row">
      <pdq-dropdown
        [formControl]="formGroup.get('settings.productDetails.discountConfiguration.discountType')"
        title="Discount Type"
        [options]="couponTypeOptions"
        optionLabel="label"
        optionValue="value">
      </pdq-dropdown>
      <pdq-input-arrows
        [formControl]="formGroup.get('settings.productDetails.discountConfiguration.discountValue')"
        label="Discount value"
        widthSize="auto"
        precision="2"
        min="1"
        [max]="
          formGroup.get('settings.productDetails.discountConfiguration.discountType').value === CouponType.PERCENTAGE
            ? 100
            : undefined
        "
        [symbol]="
          formGroup.get('settings.productDetails.discountConfiguration.discountType').value === CouponType.PERCENTAGE
            ? '%'
            : shopCurrencySymbol
        ">
      </pdq-input-arrows>
    </div>
    <pdq-input
      [formControl]="formGroup.get('settings.productDetails.discountConfiguration.label')"
      label="Append a label to the product name"
      placeholder="e.g., (25% Off)">
    </pdq-input>
  }

  @if (!isAutoApplyEnabled && giftMessageEnabled) {
    <div formGroupName="offer">
      <pdq-checkbox formControlName="displayAsPopUp" label="Display As Pop Up" labelSize="small"> </pdq-checkbox>
    </div>
  }

  @if (!isAutoApplyEnabled) {
    <ng-container formGroupName="offer">
      <pdq-input [formControl]="formGroup.get('giftPopup.title')" label="Display Title"></pdq-input>
      <pdq-input [formControl]="formGroup.get('giftPopup.text')" label="Display Subtitle"></pdq-input>

      @if (isMultipleGifts) {
        <div class="variant-selector-section">
          <span class="field-label">Variant Selector</span>
          <pdq-radio-group formControlName="variantSelector">
            <pdq-radio-button
              [value]="VariantSelectorType.INSIDE"
              text="Always Show"
              subText="Dropdown is always visible above or next to the main CTA button"
              [checked]="formGroup.get('offer.variantSelector').value === VariantSelectorType.INSIDE">
            </pdq-radio-button>
            <pdq-radio-button
              [value]="VariantSelectorType.OUTSIDE"
              text="Popup"
              subText="Dropdown appears when clicking the main CTA button"
              [checked]="formGroup.get('offer.variantSelector').value === VariantSelectorType.OUTSIDE">
            </pdq-radio-button>
          </pdq-radio-group>
        </div>
      }

      <div class="flex-row">
        @if (isMultipleGifts && formGroup.get('offer.variantSelector').value === VariantSelectorType.OUTSIDE) {
          <pdq-input formControlName="buttonTextForVariants" label="Button Text For Products With Variants"></pdq-input>
        }
        <pdq-input [formControl]="formGroup.get('giftPopup.actionButtonText')" label="Button Display Text"></pdq-input>
      </div>

      <div class="flex-row">
        <pdq-dropdown
          formControlName="buttonAppearance"
          title="Button Appearance"
          [options]="buttonAppearanceOptions"
          optionLabel="label"
          optionValue="value">
        </pdq-dropdown>
        @if (giftMessageEnabled && formGroup.get('offer.displayAsPopUp').value) {
          <div class="decline-button-field">
            <pdq-checkbox formControlName="declineButtonEnabled" label="Decline Button Text" labelSize="small">
            </pdq-checkbox>
            @if (formGroup.get('offer.declineButtonEnabled').value) {
              <pdq-input [formControl]="formGroup.get('giftPopup.declineButtonText')" label=""></pdq-input>
            }
          </div>
        }
      </div>
    </ng-container>

    <div class="advanced-styling-container">
      <span class="subtitle-small">Advanced styling</span>

      <span class="subtitle-small">Main Background</span>
      <extension-appearance-style [formGroup]="formGroup.get('offerStyle.mainBackground')">
      </extension-appearance-style>

      <span class="subtitle-small">Image</span>
      <extension-appearance-style [formGroup]="formGroup.get('offerStyle.image')"> </extension-appearance-style>
    </div>
  }
</ng-container>
